import React from 'react'
import { Modal, useModalContext, Button } from '@ally/metronome-ui'
import allytm from '@ally/allytm'
import TrashIcon from '../../../assets/icons/trash_icon.svg'
import { Beneficiary } from '../../../types'
import { IraDeleteModalContent } from './IraDeleteModalContent'
import { NonIraDeleteModalContent } from './NonIraDeleteModalContent'

const DeleteButton: React.FC<{
  isIraPage: boolean
  accountLabel: string
}> = ({ isIraPage, accountLabel }) => {
  const { setOpen } = useModalContext()

  return (
    <Button
      onClick={(): void => {
        allytm.event(
          'modalView',
          isIraPage
            ? 'AOS:Beneficiaries:Bank IRAs:Delete Beneficiary'
            : 'AOS:Beneficiaries:Bank Checking Savings and CDs:Delete Beneficiary',
          {
            treatAsPageview: true,
          },
        )
        setOpen(true)
      }}
      unsupportedContent={<TrashIcon />}
      variant="link"
      data-testid="delete-modal-trigger"
      ariaLabel="Delete Beneficiary"
      allytmln={`delete beneficiary-${accountLabel}`}
    />
  )
}

export const DeleteBeneficiaryModal: React.FC<{
  beneficiaryId: string
  accountId: string // account id or plan id
  accountLabel: string
  beneficiaries?: Beneficiary[]
  isIraPage: boolean
}> = ({ beneficiaryId, accountId, beneficiaries, isIraPage, accountLabel }) => {
  return (
    <Modal
      trigger={
        <DeleteButton isIraPage={isIraPage} accountLabel={accountLabel} />
      }
      content={
        isIraPage ? (
          <IraDeleteModalContent
            beneficiaryId={beneficiaryId}
            planId={accountId}
            beneficiaries={beneficiaries}
          />
        ) : (
          <NonIraDeleteModalContent
            beneficiaryId={beneficiaryId}
            accountId={accountId}
            beneficiaries={beneficiaries}
          />
        )
      }
      fullScreenMd
      width="md"
      disableCloseOnOverlayClick
    />
  )
}
